import React, { Component } from "react";
import { Grid, Row, Col, Table, Tooltip, OverlayTrigger , FormGroup, ControlLabel, FormControl} from "react-bootstrap";
import Card from "components/Card/Card.jsx";
import CustomButtom from "components/CustomButton/CustomButton.jsx";
import { fetchEmployeesRequest, deleteEmployeeRequest } from "../../api/employee";
import { getFullName } from "../../helpers/functions/employee";
import PaginationComponent from "components/Pagination/Pagination";
import { calcStartEndPage } from "helpers/functions/pagination";
import { debounce } from 'lodash';
import { departmentSelectOptionRequest } from "api/department";
import { positionSelectOptionRequest } from "api/position";
import { employeeStatusSelectOptions } from "variables/Variables";

class EmployeeList extends Component {

  state = {
    employees: null,
    error: null,
    filters: {
      page: 0,
      limit: 25,
      term: '',
      department: '',
      position: '',
      status: ''
    },
    total: 0,
    pages: 0,
    current_page: 0,
    start_page: 0,
    end_page: 9,
    first_page: 0,
    last_page: 0,
    loading: true,
    departmentSelectOptions: [],
    positionSelectOptions: []
  };

  debounceMethod = null;

  componentDidMount() {

    departmentSelectOptionRequest(
      result => this.setState({ departmentSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );

    positionSelectOptionRequest(
      result => this.setState({ positionSelectOptions: result }),
      error => this.setState({ error: "There was an error" })
    );

    if (!this.state.employees)
      this.fetchEmployees()
  }

  fetchEmployees(){

    const { filters } = this.state;

    fetchEmployeesRequest(
      filters,
      result => {
        const total = result.total;
        const pages = Math.ceil(total / filters.limit);
        const last_page = pages - 1;
        // const end_page = pages > 10 ? 9 : pages - 1;
        const { start_page, end_page } = calcStartEndPage(filters.page, pages);
        this.setState({
          employees: result.employees, 
          last_page, end_page, 
          total, 
          pages, 
          start_page, 
          current_page: filters.page, 
          error: null,
          loading: false
        })
      },
      error => this.setState({error: error, loading: false})
    )
  };

  goToEmployeeDetails = (id) => {
    this.props.history.push(`/employees/details/${id}`)
  }

  goToEmployeeEditForm = (id) => {
    this.props.history.push(`/employees/edit/${id}`)
  }

  deleteEmployee = async (id) => {
    deleteEmployeeRequest(
      id,
      result => this.fetchEmployees(),
      error =>
        this.setState({ error: "There was an error deleting instance" })
    );
  }

  goToPage = async (page) => {
    this.setState((prevState) => ({
      filters: {
        ...prevState.filters,
        page
      }
    }), this.fetchEmployees);
  }

  handleFilterChange = (event) => {
    const { value, name } = event.target;
    if(this.debounceMethod) {
      this.debounceMethod.cancel();
    }
    this.debounceMethod = debounce(() => this.fetchEmployees(), 500);
    this.setState((prevState) => ({ filters: { ...prevState.filters, [name]: value } }), this.debounceMethod);
  }

  render() {

    const { employees, pages, current_page, start_page, end_page, filters, positionSelectOptions, departmentSelectOptions } = this.state;
    const view = <Tooltip id="view_tooltip">View</Tooltip>;
    const edit = <Tooltip id="edit_tooltip">Edit</Tooltip>;
    const remove = <Tooltip id="remove_tooltip">Remove</Tooltip>;

    const { term, department, position, status } = filters;
    
    return (
      <div className="content">
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Employees"
                category="List of all employees"
                ctTableFullWidth
                ctTableResponsive
                content={
                  <>
                  <Col sm={12}>
                    <FormGroup>
                      <ControlLabel>Search</ControlLabel>
                      <FormControl
                          type="text"
                          name="term"
                          value={term}
                          onChange={this.handleFilterChange}
                          placeholder=""
                      />
                    </FormGroup>
                  </Col>
                  <Col sm={4}>
                    <FormGroup>
                      <ControlLabel>Department</ControlLabel>
                      <FormControl
                        componentClass="select" 
                        name="department"
                        value={department}
                        onChange={this.handleFilterChange}
                      >
                        <option value="">Select</option>
                        {departmentSelectOptions.map(option => {
                          return (
                            <option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          );
                        })}
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col sm={4}>
                    <FormGroup>
                      <ControlLabel>Position</ControlLabel>
                      <FormControl
                        componentClass="select" 
                        name="position"
                        value={position}
                        onChange={this.handleFilterChange}
                      >
                        <option value="">Select</option>
                        {positionSelectOptions.map(option => {
                          return (
                            <option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          );
                        })}
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Col sm={4}>
                    <FormGroup>
                      <ControlLabel>Status</ControlLabel>                      
                      <FormControl 
                        name="status"
                        componentClass="select" 
                        value={status}
                        onChange={this.handleFilterChange}
                      >
                        <option value="">Select</option>
                        {employeeStatusSelectOptions.map(option => {
                          return (
                            <option
                              key={option.value}
                              value={option.value}
                            >
                              {option.label}
                            </option>
                          );
                        })}
                      </FormControl>
                    </FormGroup>
                  </Col>
                  <Table striped hover>
                    <thead>
                      <tr>
                        <th>Employee Number</th>
                        <th>Full Name</th>
                        <th>Department</th>
                        <th>Position</th>
                        <th>Status</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                    { this.state.loading ? 
                      <td colSpan="9" style={{padding: "0"}}>
                         <div className="loader"></div>
                      </td> 
                     : 
                      employees && employees.length > 0 
                      ? employees.map(employee => {
                        return (
                          <tr key={employee._id}>
                            <td>{employee.employeeNumber || 'N/A'}</td>
                            <td>{getFullName(employee) || 'N/A'}</td>
                            <td>{employee.department ? employee.department.departmentName : 'N/A'}</td>
                            <td>{employee.position ? employee.position.positionName : 'N/A'}</td>
                            <td>{employee.status || 'N/A'}</td>
                            <td className="td-actions text-right">
                              <OverlayTrigger placement="top" overlay={view}>
                                <CustomButtom 
                                  bsStyle="success" 
                                  simple 
                                  type="button" 
                                  bsSize="xs"
                                  onClick={() => this.goToEmployeeDetails(employee._id)}
                                >
                                  <i className="fa fa-eye" />
                                </CustomButtom>
                              </OverlayTrigger>
                              <OverlayTrigger placement="top" overlay={edit}>
                                <CustomButtom 
                                  bsStyle="info" 
                                  simple 
                                  type="button" 
                                  bsSize="xs"
                                  onClick={() => this.goToEmployeeEditForm(employee._id)}
                                >
                                  <i className="fa fa-edit" />
                                </CustomButtom>
                              </OverlayTrigger>
                              <OverlayTrigger placement="top" overlay={remove}>
                                <CustomButtom 
                                  bsStyle="danger" 
                                  simple 
                                  type="button" 
                                  bsSize="xs"
                                  onClick={() => this.deleteEmployee(employee._id)}
                                >
                                  <i className="fa fa-times" />
                                </CustomButtom>
                              </OverlayTrigger>
                            </td>
                          </tr>
                        )
                      })
                      :
                       (
                        <tr>
                          <td colSpan='5'>There are no employees in the database yet.</td>
                        </tr>
                      )
                    }
                    </tbody>
                  </Table>
                  {employees && employees.length > 0 && 
                    <Col sm={12} className="text-right" style={{float: 'unset'}}>
                      <PaginationComponent 
                        pages={pages}
                        current_page={current_page}
                        start_page={start_page}
                        end_page={end_page}
                        goToPage={this.goToPage}
                      />
                    </Col>
                  }
                  </>
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

export default EmployeeList;
